import mutations from './packagesSelect.mutations'
import actions from './packagesSelect.actions'
import getters from './packagesSelect.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
